import { LOADING } from "../../../constants/constant";
import {
  GET_ADMIN_CAMPAIGN_REQUESTED,
  GET_ADMIN_CAMPAIGN_SUCCESS,
  GET_ADMIN_CAMPAIGN_FAILED,
  GET_ADMIN_CAMPAIGN_RESET
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: true,
};

export default function getAdminCampaignReducer(state = initialState, action) {
  switch (action.type) {
    case GET_ADMIN_CAMPAIGN_REQUESTED: {
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;
    }

    case GET_ADMIN_CAMPAIGN_SUCCESS: {
      let userRes = Object.assign({}, state);
      console.log("🚀 ~ file: get_admin_campaign_reducer.js ~ line 25 ~ getAdminCampaignReducer ~ userRes", userRes)
      // console.log(
      //   "getCarrierSubmittedBotsReducer => Case => Success: while getting submitted bots list: " +
      //     JSON.stringify(action.data)
      // );
      userRes.status = action.data.statusMessage;
      userRes.statusCode = action.data.status_code;
      userRes.isLoading = false;
      //   userRes.statusCode = action.data.status;
      userRes.campaignList = action.data.data;

      return userRes;
    }
    case GET_ADMIN_CAMPAIGN_FAILED: {
      console.error(
        "GET_ADMIN_CAMPAIGN_ => Case => Error: while getting submitted campaign list: " +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);
    }

    case GET_ADMIN_CAMPAIGN_RESET: {
      return initialState;
    }

    default:
      return state;
  }
}